module.exports = __webpack_public_path__ + "img/white.b53257ce.svg";